import React from 'react';
import ReactDOM from 'react-dom/client';
// import dotenv from "dotenv"
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
// dotenv.config()
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  // <React>
     <Provider store={store}>
      {/* <BrowserRouter forceRefresh={true}> */}
        <App />
      {/* </BrowserRouter> */}
    </Provider>
  // </React>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
